<template>
  <div am-toltip style="position:absolute" v-if="formulaData?.length && number">
    <div v-for="formula in formulaData" :key="formula.id">
      <p am-title class="_text:semibold">{{ formula.description }}</p>
      <p class="_padding-bottom: 1/4" v-if="Object.keys(formula.newMeaning).length">Meaning</p>
      <div
        v-for="mean in formula.newMeaning"
        :key="mean.key"
      >
        <p
          class="_margin:0"
          :am-maim-meaning="
            value?.toString().includes(',') && value.split(',').includes(mean.key)
              ? ''
              : mean.key?.toString() === value?.toString()
              ? ''
              : null"
        >
          {{ mean.key }} - {{ typeof mean?.value === 'string' ? mean.value : mean.value?.name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, defineProps } from 'vue'
const store = useStore()
const props = defineProps(['number', 'value'])
const formulaData = computed(() => {
  return store.getters['formula/filterForNumber'](props.number)
})
</script>

<style lang="scss">
.-dark {
  [am-toltip] {
    background: var(--color--dark-55);
    border: 1px var(--color--dark-35);
    color: white;
  }
}
.-light {
  [am-toltip] {
    background: var(--color--light-45);
    border: 1px var(--color--light-35);
    color: black;
  }
}
[am-toltip] {
  position: absolute;
  top: 28px;
  z-index: 2;
  text-align: start;
  display: none;
  padding: 10px;
  border-radius: 10px;
  width: max-content;
  max-width: 15rem;
  [am-maim-meaning] {
    font-weight: var(--font-weight--semibold) !important;
  }
  [am-title] {
    padding: 10px 0;
    text-transform: uppercase;
  }
  p {
    text-wrap: wrap;
  }
}
</style>
